export enum ProfilePreferenceCode {
	RecentCusomersListIds = "recent.customers.list.ids"
}
